import React from "react";
import ReactDOM from "react-dom";

// Graph
import { ApolloProvider } from "@apollo/client";
import ApolloClient from "services/ApolloClientService";

// Styles
import "./assets/style/global-styles.scss";

import { GlobalStateProvider, AddWidget } from "contexts/GlobalState";

import Utils from "services/Utils";

window.Utils = new Utils();
let typeContent ="";
if(window.location.pathname=='/he/search-global')
{
  typeContent=["program","general_content"];
}
else{
  typeContent="program";
}
const globalStateInitial = {
  search: {
    results: "",
    filters: {
      isSearch: false,
      langcode:"he",
      type:typeContent,
    },
  },
  user:{
    filters: {}
  },
  calc:{
    showOtherWidgets: false
  }
 
};
// Setup a general provider with a binding widgets list
ReactDOM.render(
  <ApolloProvider client={ApolloClient.client}>
    <GlobalStateProvider store={globalStateInitial} />
  </ApolloProvider>,
  document.createElement("div")
);
// ======================== function: CRWidgets ======================== //

// CRWidgets object
!window.CRWidgets && (window.CRWidgets = {});

// Register Widget
window.registerWidget = function (name, component) {
  // set CRWidgets render function
  CRWidgets[name] = function (el, settings) {
    ReactDOM.unmountComponentAtNode(el);
    AddWidget(
      ReactDOM.createPortal(React.createElement(component, settings), el)
    );
  };
};
